import { parse } from "date-fns";
export const isValidDate = (date) => !Number.isNaN(date.valueOf());
export const parseDate = (value, format, date) => {
    const referenceDate = date && isValidDate(date) ? date : new Date();
    if (value === "") {
        return null;
    }
    // padEnd prevents partial numeric values from being parsed as valid
    return parse(value.padEnd(format.length, "_"), format, referenceDate);
};
export const areDatesDifferent = (date1, date2) => {
    const date1Value = date1?.valueOf();
    const date2Value = date2?.valueOf();
    return date1Value !== date2Value && !(Number.isNaN(date1Value) && Number.isNaN(date2Value));
};
